import { uiText, formatUiDate, getUiLocale } from './uiTranslation';

// Only presentation fields are rebuilt; subscription IDs/status remain raw.
export const subscriptionDisplay = (data = {}, language = getUiLocale()) => {
  const tr = (key, values = {}) => uiText(key, { ...values, lng: language });
  let plan = data.plan;
  if (data.planName) {
    plan = tr(data.planName);
    if (data.seatLimit === 'unlimited') plan = tr('{{plan}} (Unlimited seats)', { plan });
    else if (data.seatLimit) plan = tr('{{plan}} (Up to {{count}} seats)', { plan, count: data.seatLimit });
  }
  const billingDate = data.billingAt
    ? tr('Next Billing Date: {{date}}', { date: formatUiDate(data.billingAt, { year: 'numeric', month: 'long', day: 'numeric' }, language) })
    : tr('Next Billing Date: Inapplicable');
  const statusLabels = { active: 'Active', trialing: 'Trialing', unlimited: 'Unlimited', canceled: 'Canceled', cancelled: 'Cancelled', past_due: 'Past due', unpaid: 'Unpaid', incomplete: 'Incomplete', incomplete_expired: 'Expired', paused: 'Paused' };
  const status = data.statusCode
    ? tr('Status: {{status}}', { status: tr(statusLabels[data.statusCode] || 'Unknown status') })
    : tr('Status: Inapplicable');
  return { plan, billingDate, status };
};
